<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header'>Workshop Invoicing</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/workshop/defects'><i class="fas fa-arrow-left"></i> Back</button>
    </div>
  </div>

  <br />

  @if (this.isServerError) {
    <div class="alert alert-danger">{{ this.serverErrorMessage }}</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Invoice(s) raised successfully</div>
  }

  <p class='invoicingHint'>Completed defects not yet invoiced. Select the ones to bill back to their vehicle's depot, then raise the invoice(s).</p>

  <table class='invoicingTable'>
    <thead>
      <tr>
        <th></th>
        <th>#</th>
        <th>Vehicle</th>
        <th>Depot</th>
        <th>Description</th>
        <th>Parts Total</th>
        <th>Labour Total</th>
      </tr>
    </thead>
    <tbody>
      @if (this.defects.length === 0) {
        <tr>
          <td colspan="7" class='text-muted'>Nothing to invoice</td>
        </tr>
      }
      @for (defect of this.defects; track defect.id) {
        <tr>
          <td><input type='checkbox' [checked]='this.isSelected(defect)' (change)='this.toggleSelected(defect)'></td>
          <td>{{ defect.id }}</td>
          <td>{{ defect.vehicle.registration }}</td>
          <td>{{ defect.vehicle.depot?.name }}</td>
          <td>{{ defect.description }}</td>
          <td>£{{ this.partsTotal(defect).toFixed(2) }}</td>
          <td>£{{ this.labourTotal(defect).toFixed(2) }}</td>
        </tr>
      }
    </tbody>
  </table>

  <br />
  <button class='btn btn-success' [disabled]='this.selectedIds.size === 0' (click)='this.raiseInvoices()'><i class="fas fa-file-invoice"></i> Raise Invoice(s)</button>
</div>
